<template>
  <div>
    <v-server-table
      :columns="columns"
      :url="stockUrl"
      :options="options"
      :theme="theme"
      id="StockTable"
      ref="table"
    >
      <div slot="h__id">
        <input
          type="checkbox"
          class="form-check check-all"
          v-model="allMarked"
          @change="toggleAll"
        />
      </div>

      <template slot="id" scope="props">
        <input
          type="checkbox"
          :ref="'check' + props.index"
          @click="
            unmarkAll(
              $event,
              props.row.net_kilograms.format(),
              props.index,
              'check' + props.index,
              props.row
            )
          "
          class="form-check"
          :value="props.row"
          v-model="markedRows"
          :disabled="isRechazado(props.row)"
          :title="
            isRechazado(props.row)
              ? 'Pallet rechazado - No disponible para proceso'
              : ''
          "
        />
      </template>

      <template slot="condition" slot-scope="props">
        <b-badge pill :variant="getBadge(props.row.condition)">{{
          props.row.condition
        }}</b-badge>
      </template>
      <template slot="daystay" slot-scope="props">
        <div style="text-align: right">
          <b-badge pill :variant="getDaystayBadge(props.row.daystay)">
            {{ props.row.daystay }}
          </b-badge>
        </div>
      </template>
      <div slot="afterFilter">
        <!--      ASADF-->
      </div>
      <div slot="net_kilograms" slot-scope="props">
        <div style="text-align: right">
          {{ props.row.net_kilograms.format("0,0.00") }}
        </div>
      </div>
      <div slot="quantity" slot-scope="props">
        <div style="text-align: right">{{ props.row.quantity }}</div>
      </div>
      <div slot="waybill_number" slot-scope="props">
        <div style="text-align: right">{{ props.row.waybill_number }}</div>
      </div>
      <div slot="waybill_date" slot-scope="props">
        <div style="text-align: right">{{ props.row.waybill_date }}</div>
      </div>
      <div slot="last_inspection" slot-scope="props">
        <div v-if="props.row.last_inspection.inspection">
          <span
            :class="
              getBadgeInspection(props.row.last_inspection.color_status_pallet)
            "
            >{{ props.row.last_inspection.status_pallet }}</span
          >
        </div>
      </div>
      <div slot="rechazo" slot-scope="props">
        <div v-if="props.row.rechazo">
          <b-badge pill variant="danger">{{ props.row.rechazo }}</b-badge>
        </div>
      </div>
    </v-server-table>

    <b-modal
      v-model="palletApprovedModal"
      centered
      size="xs"
      title="Aprobar pallet"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <h3>Seguro que quieres ingresar este pallet?</h3>

      <p>
        El pallet que quiere ingresar necesita autorización por su resultado en
        control de calidad
      </p>

      <form ref="form" @submit.prevent="submitModal">
        <b-form-group label="Responsable">
          <b-form-select
            id="supervisor"
            :state="
              $v.palletApprovedResponsable.$dirty
                ? !$v.palletApprovedResponsable.$error
                : null
            "
            v-model="palletApprovedResponsable"
            :options="supervisors"
          />
        </b-form-group>

        <b-form-group>
          <label>Observación</label>
          <b-form-textarea
            v-model="palletApprovedObservation"
            placeholder=""
            rows="3"
            max-rows="6"
          >
          </b-form-textarea>
        </b-form-group>

        <div class="col text-center">
          <b-button type="submit" variant="primary">SI</b-button> &nbsp;
          <b-button type="button" variant="danger" @click="ModalCancel"
            >NO</b-button
          >
          &nbsp;
        </div>
      </form>
    </b-modal>

    <authorization-modal
      v-if="this.methodDynamic != null"
      :modal="Modalauthorization"
      :obj="currentObj"
      @hideAuthorizationModal="hideAuthorizationModal"
      v-on="{ methodDynamic: methodDynamic }"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event, ServerTable } from "vue-tables-2";
import AgregarContenidoModal from "./AgregarContenidoModal";
import moment from "moment";
import modals from "../recepcion/DetalleRecepcionModal";
import numeral from "numeral";
import locales from "numeral/locales";
import _ from "lodash";
import authorizationModal from "../reusable/authorizationModalQC";

import {
  required,
  numeric,
  minLength,
  between
} from "vuelidate/lib/validators";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

Vue.use(ServerTable);
window.axios = require("axios");

export default {
  name: "StockTable",
  components: {
    ServerTable,
    AgregarContenidoModal,
    authorizationModal
  },
  props: [
    "tableType",
    "stockUrl",
    "processData",
    "kilogramDiference",
    "supervisors"
    // 'markedRows',
  ],
  data() {
    return {
      palletApprovedModal: false,
      palletApprovedResponsable: "",
      palletApprovedObservation: "",
      objModalAux: {
        obj: "",
        objcompleto: ""
      },
      columns: [
        "id",
        "lot_number",
        "waybill_number",
        "origin_name",
        "pallet_number",
        "product_name",
        "product_type_name",
        "condition",
        "variety_name",
        "container_name",
        "quantity",
        "net_kilograms",
        "daystay",
        "string_specs",
        "in_process",
        "last_inspection",
        "rechazo"
      ],
      allMarked: false,
      markedRows: [],
      palletApprovedRows: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        rowClassCallback: function (row) {
          // Si tiene rechazo con la palabra "rechazado", aplicar estilo de error
          if (row.rechazo && row.rechazo.toLowerCase().includes("rechazado")) {
            return "table-danger";
          }
          return row.in_process ? "text-muted" : "";
        },
        debounce: 1000,
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].waybill_date = moment(
              results[key].waybill_date
            ).format("DD-MM-YYYY");
            results[key].net_kilograms = numeral(
              parseFloat(results[key].net_kilograms)
            );
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        filterByColumn: true,
        filterable: [
          "lot_number",
          "pallet_number",
          "waybill_number",
          "origin_name",
          "product_type_name",
          "container_name",
          "in_process"
        ],
        perPage: 10,
        headings: {
          pallet_number: "Pallet",
          lot_number: "Lote",
          waybill_number: "Guia",
          product_name: "Producto",
          product_type_name: "Tipo Producto",
          condition: "Condición",
          variety_name: "Variedad",
          container_name: "Contenedor",
          quantity: "Cantidad",
          in_process: "En Proceso",
          net_kilograms: "KN",
          daystay: "Días estadía",
          string_specs: "Especificaciones",
          origin_name: "Huerto",
          last_inspection: "Inspección",
          rechazo: "Rechazo"
        },
        columnsDropdown: true,
        columnsDisplay: {
          document: "not_desktop",
          product_name: "not_desktop",
          variety_name: "not_desktop",
          product_type_name: "min_desktop",
          string_specs: "min_desktop",
          condition: "not_desktop",
          origin_name: "not_desktop",
          lot_number: "min_desktop"
        },
        sortable: ["number", "company_name"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        },
        perPageValues: [5, 10, 50, 100]
      },
      Modalauthorization: false,
      currentObj: null,
      methodDynamic: null
    };
  },
  validations: {
    palletApprovedResponsable: { required }
  },
  computed: {
    sumMarkedKilograms() {
      let total = 0;
      total += this.markedRows.reduce(
        (acc, item) => acc + item.net_kilograms.value(),
        0
      );
      total = parseFloat(total.toFixed(2));
      return numeral(total);
    },
    sumNetKilograms() {
      let total = 0;

      if (this.data != null) {
        total += this.data.reduce(
          (acc, item) => acc + item.net_kilograms.value(),
          0
        );
        total = numeral(total);
      }

      return total;
    }
  },
  watch: {
    Modalauthorization: function (val, oldVal) {
      // if (val == false) {
      //   this.$refs[this.currentObj].checked = false;
      // }
    },
    markedRows(val) {
      this.$store.dispatch("updateProcessMarkedRows", val);
    },
    sumMarkedKilograms(val) {
      this.$emit("sumMarkedKilograms", this.sumMarkedKilograms);
    },
    sumNetKilograms(val) {
      this.$emit("sumNetKilograms", this.sumNetKilograms);
    }
  },
  methods: {
    isRechazado(row) {
      if (!row.rechazo) return false;
      return row.rechazo.toLowerCase().includes("rechazado");
    },
    hideAuthorizationModal() {
      this.Modalauthorization = false;
    },
    authorizationUser(obj, method) {
      this.currentObj = obj;
      this.Modalauthorization = true;
      this.methodDynamic = method;
    },
    getBadge(condition) {
      return condition === "Orgánico" ? "primary" : "success";
    },
    getBadgeInspection(color) {
      return `badge badge-${color}`;
    },
    getDaystayBadge(daystay) {
      return daystay >= 10
        ? "danger"
        : daystay >= 5
        ? "warning"
        : daystay >= 3
        ? "success"
        : "primary";
    },
    submitModal() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        miniToastr.warn("Campos requeridos en el formulario ");
      } else {
        this.palletApprovedModal = false;

        var objPayload = {
          process_id: this.processData.id,
          content_id: this.objModalAux.objcompleto.id,
          lotqc_id: this.objModalAux.objcompleto.last_inspection.id,
          palletApprovedResponsable: this.palletApprovedResponsable,
          palletApprovedObservation: this.palletApprovedObservation,
          action: "Ingreso a proceso"
        };

        this.palletApprovedRows.push(objPayload);
        this.$refs[this.objModalAux.obj].checked = true;

        this.palletApprovedResponsable = "";
        this.palletApprovedObservation = "";
      }
    },
    ModalCancel() {
      this.palletApprovedModal = false;
      this.$refs[this.objModalAux.obj].checked = false;
    },
    async checkIfItemIsOnAnotherProcess(objcompleto) {
      try {
        const res = await this.$axios.get(
          `/api/v1/process/${objcompleto.id}/check_content_in_process/`
        );
        // Status 0: disponible
        // Status 1: está en proceso
        // Status 2: está rechazado
        if (res.data.status == 1) {
          // Si el item esta en otro proceso
          return true;
        }
        return false;
      } catch (error) {
        console.log(error.message);
        return false;
      }
    },
    async unmarkAll($event, kilosNetos, index, obj, objcompleto) {
      this.objModalAux.obj = obj;
      this.objModalAux.objcompleto = objcompleto;
      if ($event.target.checked == true) {
        const checkPromise = await this.checkIfItemIsOnAnotherProcess(
          objcompleto
        );
        const check = await checkPromise;
        if (check) {
          miniToastr.warn("El item esta en otro proceso");
          this.$refs[obj].checked = false;
          return;
        }
      }

      if ($event.target.checked == false) {
        if (
          Math.fround(kilosNetos) <= Math.fround(this.kilogramDiference.value())
        ) {
          let deleteIndex = this.palletApprovedRows.findIndex(
            (item) => item.content_id === objcompleto.id
          );

          this.palletApprovedRows.splice(deleteIndex, 1);

          // console.log(kilosNetos+" Aqui "+this.kilogramDiference.format());

          this.$axios
            .get(
              "/api/qc/pallet-approval/check_pallet_approval/?" +
                "content_id=" +
                objcompleto.id
            )
            .then((res) => {
              if (res.data.status == 1) {
                var removeApprovedPallet = [];

                var objPayload = {
                  process_id: this.processData.id,
                  content_id: objcompleto.id,
                  lotqc_id: objcompleto.last_inspection.id,
                  palletApprovedResponsable: "",
                  palletApprovedObservation: "",
                  action: "Devuelto a stock en proceso"
                };

                removeApprovedPallet.push(objPayload);

                this.$axios
                  .post(
                    "/api/qc/pallet-approval/new_pallet_approval/",
                    removeApprovedPallet
                  )
                  .then((res) => {})
                  .catch((error) => console.log(error.message));
              }
            })
            .catch((error) => console.log(error.message));
        } else {
          //  console.log("Negativo el procedimiento ");
          //this.$refs[obj].checked = false;
          this.$refs[obj].checked = true;
          //this.$refs[obj].disabled = true;

          miniToastr.warn(
            "Operación no permitida,  los kilos Netos que quiere sacar son superiores a los de la cuadratura.",
            ""
          );
        }
      } else {
        //console.log("chekiando %o", objcompleto);

        if (
          objcompleto.last_inspection.status_pallet == "Rechazado" ||
          objcompleto.last_inspection.status_pallet == "Objetado"
        ) {
          this.authorizationUser(obj, this.returnValidationLoginQC);
        }
      }

      this.allMarked = false;
    },
    returnValidationLoginQC(obj, result) {
      this.$nextTick(() => {
        this.$refs[obj].checked = result;
      });
    },
    toggleAll() {
      this.markedRows = this.allMarked ? this.$refs.table.data : [];
    },
    validateAndTraceability() {
      if (this.markedRows.length > 0) {
        const formData = {
          id_proceso: this.processData.id,
          contenido: this.markedRows,
          tipo: 1
        };

        axios
          .post("/api/v1/process/traceability_process/", formData)
          .then((res) => {
            // TODO: QUE HACE ESTO??
          })
          .catch((error) => console.log(error.message));

        axios
          .post(
            "/api/qc/pallet-approval/new_pallet_approval/",
            this.palletApprovedRows
          )
          .then((res) => {})
          .catch((error) => console.log(error.message));

        return 1;
      } else {
        return 0;
      }
    },
    validateMarkedRows() {
      //console.log(this.markedRows.length);

      if (this.markedRows.length > 0) {
        return 1;
      } else {
        return 0;
      }
    }
  }
};
</script>

<style lang="scss">
#StockTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
